import { Component, input } from '@angular/core';
import {
  BadgeComponent as SdcBadgeComponent,
  BadgeVariant,
} from '@3ddv/software-division-components/backoffice/badge';

@Component({
  selector: 'gs-badge-cell',
  imports: [SdcBadgeComponent],
  template: `<sdc-badge [variant]="variant()">{{ text() }}</sdc-badge>`,
  host: { '[attr.data-cy]': 'dataCy() || null' },
})
export class GsBadgeCellComponent {
  readonly text = input('');
  readonly variant = input<BadgeVariant>('neutral');
  readonly dataCy = input('');
}
